export default "__VITE_ASSET__CdWq7raa__"